export const getOffsetString = (value: string | number): string => {
  if (value === 0 || value === '') {
    return '0'
  }
  const totalMinutes = typeof value === 'string' ? parseInt(value, 10) : value
  const sign = totalMinutes < 0 ? '-' : ''
  const abs = Math.abs(totalMinutes)
  const hours = Math.floor(abs / 60)
  const minutes = abs % 60

  if (hours === 0) {
    return `${sign}${minutes} min${minutes !== 1 ? 's' : ''}`
  }
  return `${sign}${hours} hour${hours !== 1 ? 's' : ''} ${minutes} min${minutes !== 1 ? 's' : ''}`
}
